/**
 * Read-only PRIVATE calendar share (storefront).
 * Fetches published events via public API token.
 */
(function () {
  var API_BASE = 'https://api.ladybaeshop.com';
  var root = document.getElementById('lb-private-cal-share');
  if (!root) return;

  var apiBase = root.getAttribute('data-api-base') || API_BASE;
  var notice = document.getElementById('lb-private-cal-share-notice');
  var titleEl = document.getElementById('lb-private-cal-share-title');
  var monthLabel = document.getElementById('lb-private-cal-share-month');
  var gridHost = document.getElementById('lb-private-cal-share-grid');
  var listHost = document.getElementById('lb-private-cal-share-list');
  var prevBtn = document.getElementById('lb-private-cal-share-prev');
  var nextBtn = document.getElementById('lb-private-cal-share-next');
  var xlsxBtn = document.getElementById('lb-private-cal-share-xlsx');
  var pdfBtn = document.getElementById('lb-private-cal-share-pdf');
  var fieldsRoot = document.getElementById('lb-private-cal-share-fields');

  var events = [];
  var notices = [];
  var cursor = new Date();
  cursor.setDate(1);
  cursor.setHours(0, 0, 0, 0);

  var CAL_SOFT_PALETTE = [
    '#F8D7DA', '#D1ECF1', '#D4EDDA', '#FFF3CD', '#E2D5F1', '#FDE2D2',
    '#D6EAF8', '#E8F5E9', '#FCE4EC', '#E0F2F1', '#FFF0DB', '#E8DAEF'
  ];
  var CAL_FIELD_DEFAULTS = ['time', 'title', 'instructor', 'organizer', 'co_organizer'];
  var CAL_FIELD_STORAGE_KEY = 'lb-pcs-cal-fields';

  function hashCalPalette(seed) {
    var s = String(seed || '');
    var h = 0;
    for (var i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0;
    return CAL_SOFT_PALETTE[h % CAL_SOFT_PALETTE.length];
  }

  function normalizeCalHex(raw) {
    var s = String(raw || '').trim().replace(/^#/, '');
    if (/^[0-9A-Fa-f]{6}$/.test(s)) return '#' + s.toUpperCase();
    if (/^[0-9A-Fa-f]{3}$/.test(s)) {
      return ('#' + s[0] + s[0] + s[1] + s[1] + s[2] + s[2]).toUpperCase();
    }
    return '';
  }

  function resolveCalChipColor(stored, seed) {
    var n = normalizeCalHex(stored);
    return n || hashCalPalette(seed);
  }

  function readCalDisplayFields() {
    if (!fieldsRoot) return CAL_FIELD_DEFAULTS.slice();
    var checked = [];
    Array.prototype.forEach.call(fieldsRoot.querySelectorAll('input[data-cal-field]'), function (el) {
      if (el.checked) checked.push(String(el.getAttribute('data-cal-field') || ''));
    });
    return checked.length ? checked : CAL_FIELD_DEFAULTS.slice();
  }

  function persistCalDisplayFields() {
    try {
      localStorage.setItem(CAL_FIELD_STORAGE_KEY, readCalDisplayFields().join(','));
    } catch (e) { /* ignore */ }
  }

  function restoreCalDisplayFields() {
    if (!fieldsRoot) return;
    var saved = '';
    try { saved = String(localStorage.getItem(CAL_FIELD_STORAGE_KEY) || ''); } catch (e) { saved = ''; }
    var set = {};
    (saved ? saved.split(',') : CAL_FIELD_DEFAULTS).forEach(function (k) {
      if (k) set[k] = true;
    });
    Array.prototype.forEach.call(fieldsRoot.querySelectorAll('input[data-cal-field]'), function (el) {
      var key = String(el.getAttribute('data-cal-field') || '');
      el.checked = !!set[key];
    });
  }

  function formatCalEventLabel(ev, fields) {
    var parts = [];
    var startHm = fmtTime(ev.start_at);
    var endHm = fmtTime(ev.end_at);
    var has = {};
    (fields || []).forEach(function (f) { has[f] = true; });
    (fields || []).forEach(function (f) {
      if (f === 'time' && startHm) {
        if (has.end_time && endHm && endHm !== startHm) parts.push(startHm + '–' + endHm);
        else parts.push(startHm);
      } else if (f === 'end_time') {
        if (!has.time && endHm) parts.push('至 ' + endHm);
      } else if (f === 'title' && String(ev.title || '').trim()) {
        parts.push(String(ev.title).trim());
      } else if (f === 'instructor' && String(ev.instructor || '').trim()) {
        parts.push(String(ev.instructor).trim());
      } else if (f === 'organizer' && String(ev.organizer || '').trim()) {
        parts.push('主辦:' + String(ev.organizer).trim());
      } else if (f === 'co_organizer' && String(ev.co_organizer || '').trim()) {
        parts.push('協辦:' + String(ev.co_organizer).trim());
      } else if (f === 'venue' && String(ev.venue_name || '').trim()) {
        parts.push(String(ev.venue_name).trim());
      } else if (f === 'category' && String(ev.category || '').trim()) {
        parts.push(String(ev.category).trim());
      } else if (f === 'ticket') {
        var t = String(ev.ticket_summary || '').trim();
        if (t && t !== '—') parts.push(t);
      }
    });
    return parts.join(' · ') || String(ev.title || '').trim() || '（無標題）';
  }

  function pad2(n) {
    n = Number(n) || 0;
    return (n < 10 ? '0' : '') + n;
  }

  function isoWeekdayYmd(y, m, d) {
    return new Date(Date.UTC(y, m - 1, d)).getUTCDay() || 7;
  }

  function isoWeekNumberYmd(y, m, d) {
    var utc = new Date(Date.UTC(y, m - 1, d));
    var dow = utc.getUTCDay() || 7;
    var thu = new Date(utc);
    thu.setUTCDate(utc.getUTCDate() + 4 - dow);
    var yearStart = new Date(Date.UTC(thu.getUTCFullYear(), 0, 1));
    return Math.ceil((((thu.getTime() - yearStart.getTime()) / 86400000) + 1) / 7);
  }

  function noticeMatchesDay(n, y, m, d) {
    if (!n || n.is_enabled === false) return false;
    var kind = String(n.rule_kind || '');
    var days = n.weekdays || [];
    if (kind === 'WEEKLY') return days.indexOf(isoWeekdayYmd(y, m, d)) >= 0;
    if (kind === 'ISO_WEEK') {
      var odd = isoWeekNumberYmd(y, m, d) % 2 === 1;
      if (n.iso_parity === 'ODD' && !odd) return false;
      if (n.iso_parity === 'EVEN' && odd) return false;
      return days.indexOf(isoWeekdayYmd(y, m, d)) >= 0;
    }
    if (kind === 'MONTHLY_DAYS') return (n.month_days || []).indexOf(d) >= 0;
    return false;
  }

  function expandNoticesForMonth(list, y, m) {
    var last = new Date(y, m, 0).getDate();
    var out = [];
    (list || []).forEach(function (n) {
      if (!n || n.is_enabled === false) return;
      for (var d = 1; d <= last; d++) {
        if (!noticeMatchesDay(n, y, m, d)) continue;
        out.push({
          id: n.id,
          title: n.title,
          calendar_color: n.calendar_color,
          sort_order: n.sort_order || 0,
          ymd: y + '-' + pad2(m) + '-' + pad2(d),
          day: d
        });
      }
    });
    out.sort(function (a, b) {
      if (a.ymd !== b.ymd) return a.ymd < b.ymd ? -1 : 1;
      if (a.sort_order !== b.sort_order) return a.sort_order - b.sort_order;
      return Number(a.id) - Number(b.id);
    });
    return out;
  }

  function tokenFromUrl() {
    try {
      var params = new URLSearchParams(window.location.search);
      return String(params.get('token') || '').trim();
    } catch (e) {
      return '';
    }
  }

  function showNotice(msg) {
    if (!notice) return;
    notice.hidden = false;
    notice.textContent = msg || '';
  }

  function fmtTime(iso) {
    if (!iso) return '';
    try {
      return new Date(iso).toLocaleTimeString('zh-TW', { hour: '2-digit', minute: '2-digit' });
    } catch (e) {
      return '';
    }
  }

  function fmtRange(start, end) {
    var a = fmtTime(start);
    var b = fmtTime(end);
    if (a && b) return a + '–' + b;
    return a || b || '';
  }

  function monthParam() {
    var y = cursor.getFullYear();
    var m = cursor.getMonth() + 1;
    return y + '-' + String(m).padStart(2, '0');
  }

  function exportUrl(format) {
    var token = tokenFromUrl();
    return apiBase + '/v1/public/private-calendar/' + encodeURIComponent(token) +
      '/export?month=' + encodeURIComponent(monthParam()) +
      '&format=' + encodeURIComponent(format) +
      '&fields=' + encodeURIComponent(readCalDisplayFields().join(','));
  }

  function render() {
    var y = cursor.getFullYear();
    var m = cursor.getMonth();
    if (monthLabel) monthLabel.textContent = y + '年' + (m + 1) + '月';
    var fields = readCalDisplayFields();

    var byDay = {};
    var monthEvents = [];
    var monthNotices = expandNoticesForMonth(notices, y, m + 1);
    monthNotices.forEach(function (n) {
      if (!byDay[n.day]) byDay[n.day] = [];
      byDay[n.day].push({ kind: 'notice', notice: n });
    });
    events.forEach(function (ev) {
      if (!ev.start_at) return;
      var d = new Date(ev.start_at);
      if (d.getFullYear() !== y || d.getMonth() !== m) return;
      var day = d.getDate();
      if (!byDay[day]) byDay[day] = [];
      byDay[day].push({ kind: 'course', event: ev });
      monthEvents.push(ev);
    });

    if (gridHost) {
      var firstDow = new Date(y, m, 1).getDay();
      var daysInMonth = new Date(y, m + 1, 0).getDate();
      var html = '<div class="lb-pcs__grid">';
      ['日', '一', '二', '三', '四', '五', '六'].forEach(function (w) {
        html += '<div class="lb-pcs__dow">' + w + '</div>';
      });
      for (var i = 0; i < firstDow; i++) html += '<div class="lb-pcs__cell lb-pcs__cell--empty"></div>';
      for (var day = 1; day <= daysInMonth; day++) {
        var dayItems = byDay[day] || [];
        html += '<div class="lb-pcs__cell"><div class="lb-pcs__day">' + day + '</div>';
        dayItems.forEach(function (item) {
          if (item.kind === 'notice') {
            var nbg = resolveCalChipColor(item.notice.calendar_color, item.notice.id + ':' + (item.notice.title || ''));
            html += '<div class="lb-pcs__ev lb-pcs__ev--notice" style="background:' + nbg + '">' +
              escapeHtml(item.notice.title || '每日事項') +
              '</div>';
            return;
          }
          var ev = item.event;
          var bg = resolveCalChipColor(ev.calendar_color, ev.id + ':' + (ev.title || ''));
          html += '<div class="lb-pcs__ev" style="background:' + bg + '">' +
            escapeHtml(formatCalEventLabel(ev, fields)) +
            '</div>';
        });
        html += '</div>';
      }
      html += '</div>';
      gridHost.innerHTML = html;
    }

    if (listHost) {
      if (!monthEvents.length && !monthNotices.length) {
        listHost.innerHTML = '<p class="lb-pcs__muted">本月尚無已上架課程。</p>';
      } else {
        var listItems = [];
        monthNotices.forEach(function (n) {
          listItems.push({ kind: 'notice', ymd: n.ymd, notice: n });
        });
        monthEvents.forEach(function (ev) {
          var d = new Date(ev.start_at);
          var ymd = d.getFullYear() + '-' + pad2(d.getMonth() + 1) + '-' + pad2(d.getDate());
          listItems.push({ kind: 'course', ymd: ymd, event: ev, t: d.getTime() });
        });
        listItems.sort(function (a, b) {
          if (a.ymd !== b.ymd) return a.ymd < b.ymd ? -1 : 1;
          if (a.kind !== b.kind) return a.kind === 'notice' ? -1 : 1;
          return (a.t || 0) - (b.t || 0);
        });
        var listHtml = '';
        listItems.forEach(function (item) {
          if (item.kind === 'notice') {
            var n = item.notice;
            var nbg = resolveCalChipColor(n.calendar_color, n.id + ':' + (n.title || ''));
            listHtml += '<article class="lb-pcs__card lb-pcs__card--notice" style="border-left:4px solid ' + nbg + '">' +
              '<h3 class="lb-pcs__card-title">' + escapeHtml(n.title || '每日事項') + '</h3>' +
              '<p class="lb-pcs__meta">' + escapeHtml(n.ymd) + ' · 每日事項 · 無需報名</p>' +
              '</article>';
            return;
          }
          var ev = item.event;
          var bg = resolveCalChipColor(ev.calendar_color, ev.id + ':' + (ev.title || ''));
          listHtml += '<article class="lb-pcs__card" style="border-left:4px solid ' + bg + '">' +
            '<h3 class="lb-pcs__card-title">' + escapeHtml(ev.title || '') + '</h3>' +
            '<p class="lb-pcs__meta">' + escapeHtml(formatCalEventLabel(ev, fields)) + '</p>' +
            (ev.venue_name
              ? '<p class="lb-pcs__meta">場地：' + escapeHtml(ev.venue_name) + '</p>'
              : '') +
            '<p class="lb-pcs__meta">票價：' + escapeHtml(ev.ticket_summary || '—') + '</p>' +
            '</article>';
        });
        listHost.innerHTML = listHtml;
      }
    }
  }

  function escapeHtml(s) {
    return String(s || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  async function load() {
    var token = tokenFromUrl();
    if (!token) {
      showNotice('缺少分享連結參數，請使用完整網址開啟。');
      return;
    }
    try {
      var res = await fetch(apiBase + '/v1/public/private-calendar/' + encodeURIComponent(token), {
        headers: { Accept: 'application/json' },
      });
      var payload = await res.json().catch(function () { return null; });
      if (!res.ok || !payload || payload.ok !== true) {
        showNotice((payload && payload.error && payload.error.message) || '無法載入課表');
        return;
      }
      if (notice) notice.hidden = true;
      if (titleEl) titleEl.textContent = payload.vendor_label || '資格限定課課表';
      events = Array.isArray(payload.events) ? payload.events : [];
      notices = Array.isArray(payload.notices) ? payload.notices : [];
      if (events.length && events[0].start_at) {
        var first = new Date(events[0].start_at);
        if (!isNaN(first.getTime())) {
          cursor = new Date(first.getFullYear(), first.getMonth(), 1);
        }
      }
      render();
    } catch (err) {
      showNotice(err.message || '載入失敗');
    }
  }

  restoreCalDisplayFields();

  if (prevBtn) {
    prevBtn.addEventListener('click', function () {
      cursor.setMonth(cursor.getMonth() - 1);
      render();
    });
  }
  if (nextBtn) {
    nextBtn.addEventListener('click', function () {
      cursor.setMonth(cursor.getMonth() + 1);
      render();
    });
  }
  if (xlsxBtn) {
    xlsxBtn.addEventListener('click', function () {
      window.location.href = exportUrl('xlsx');
    });
  }
  if (pdfBtn) {
    pdfBtn.addEventListener('click', function () {
      window.open(exportUrl('pdf'), '_blank');
    });
  }
  if (fieldsRoot) {
    fieldsRoot.addEventListener('change', function () {
      persistCalDisplayFields();
      render();
    });
  }

  load();
})();
